export default 'development'



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 131